
export const getDic = (type) => {
  return new Promise((resolve, reject) => {
    resolve({ data: {}})
  })
}
